import React from 'react';
import { ConnectedCalendarModal } from './ConnectedCalendarModal';
import { ConnectionStatus } from '../../../entities/UserIntegration';
import { DisconnectedIntegrationModalBody } from '../../DisconnectedIntegrationModalBody';
import { appendQueryParam } from '../../../utils/url';

interface PropTypes {
  isOpen: boolean;
  returnTitle?: string;
  applicationId: number;
  interviewStageId: number;
  onClose: () => void;
  atsUpdateSchedulingUserIntegrationUserInfoEnabled?: boolean;
  isLoading: boolean;
  connectionStatus: ConnectionStatus;
}

export function ModalBody(props: PropTypes) {
  const reconnectUrl = appendQueryParam(
    '/account_settings/integrations',
    'state',
    window.location.href,
  );

  return (
    <>
      {!props.isLoading &&
      props.connectionStatus !== ConnectionStatus.Connected &&
      props.atsUpdateSchedulingUserIntegrationUserInfoEnabled ? (
        <DisconnectedIntegrationModalBody
          largeImage
          url={reconnectUrl}
          onClose={props.onClose}
          informationText='Your calendar got disconnected, so scheduling is on pause for now.'
          actionText='Just reconnect to pick up where you left off.'
        />
      ) : (
        <ConnectedCalendarModal
          isOpen={props.isOpen}
          applicationId={props.applicationId}
          interviewStageId={props.interviewStageId}
          onClose={props.onClose}
          returnTitle={props.returnTitle}
          isLoading={props.isLoading}
        />
      )}
    </>
  );
}
